import React, {ReactElement, FC, Component} from "react";
import {Box, Typography} from "@mui/material";
import { observer } from "mobx-react";
import Timer from "../../stores/TimerModalStore";
import { AnySrvRecord } from "dns";

type Props = {
  timer: Timer;
};

const List: FC<Props> = ({timer} : Props): ReactElement => {
  return (
    <Box sx={{
      flexGrow: 1,
      backgroundColor: 'whitesmoke',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      {timer.posts.length > 0 && timer.posts.map((post : any)=> {
        return <div>{post.userId}</div>
      })}
    </Box>
  )
}

export default observer(List);
